import face1 from "../../../assets/images/faces/1.jpg";
import face2 from "../../../assets/images/faces/2.jpg";
import face3 from "../../../assets/images/faces/3.jpg";
import face4 from "../../../assets/images/faces/4.jpg";
import face5 from "../../../assets/images/faces/5.jpg";
export const Selectoption1 = [
  { value: 'Selection-1', label: 'Selection-1' },
  { value: 'Selection-2', label: 'Selection-2' },
  { value: 'Selection-3', label: 'Selection-3' },
  { value: 'Selection-4', label: 'Selection-4' },
  { value: 'Selection-5', label: 'Selection-5' }
];
export const Selectoption2 = [
  { value: 'Multiple-1', label: 'Multiple-1' },
  { value: 'Multiple-2', label: 'Multiple-2' },
  { value: 'Multiple-3', label: 'Multiple-3' },
  { value: 'Multiple-4', label: 'Multiple-4' },
  { value: 'Multiple-5', label: 'Multiple-5' }
];
export const Selectoption3 = [
  { value: 'Texas', label: 'Texas' },
  { value: 'Georgia', label: 'Georgia' },
  { value: 'California', label: 'California' },
  { value: 'Washington D.C', label: 'Washington D.C' },
  { value: 'Virginia', label: 'Virginia' }
];

export const Selectoption4 = [
  { value: 'Appple', label: 'Appple' },
  { value: 'Mango', label: 'Mango' },
  { value: 'Orange', label: 'Orange' },
  { value: 'Guava', label: 'Guava' },
  { value: 'Pineapple', label: 'Pineapple' }
];


export const Selectmaxoption= [
  { value: 'Andrew', label: 'Andrew' },
  { value: 'Maya', label: 'Maya' },
  { value: 'Brodus Axel', label: 'Brodus Axel' },
  { value: 'Goldhens', label: 'Goldhens' },
  { value: 'Angelina', label: 'Angelina' }
];

export const Selectoption5 = [
  {
    value: 'Andrew', label: (
      <div>
        <img src={face1} alt="Andrew" className="me-2" style={{ width: '1.45rem', height: '1.45rem', borderRadius: '1.25rem', marginInlineEnd: '.25rem', boxShadow: '0 4px 16px 0 rgba(169, 184, 200, .15)' }} />
        Andrew
      </div>
    )
  },
  {
    value: 'Maya', label: (
      <div>
        <img src={face2} alt="Maya" className="me-2" style={{ width: '1.45rem', height: '1.45rem', borderRadius: '1.25rem', marginInlineEnd: '.25rem', boxShadow: '0 4px 16px 0 rgba(169, 184, 200, .15)' }} />
        Maya
      </div>
    )
  },
  {
    value: 'Brodus Axel', label: (
      <div>
        <img src={face3} alt="Brodus Axel" className="me-2" style={{ width: '1.45rem', height: '1.45rem', borderRadius: '1.25rem', marginInlineEnd: '.25rem', boxShadow: '0 4px 16px 0 rgba(169, 184, 200, .15)' }} />
        Brodus Axel
      </div>
    )
  },
  {
    value: 'Goldhens', label: (
      <div>
        <img src={face4} alt="Goldhens" className="me-2" style={{ width: '1.45rem', height: '1.45rem', borderRadius: '1.25rem', marginInlineEnd: '.25rem', boxShadow: '0 4px 16px 0 rgba(169, 184, 200, .15)' }} />
        Goldhens
      </div>
    )
  },
  {
    value: 'Angelina', label: (
      <div>
        <img src={face5} alt="Angelina" className="me-2" style={{ width: '1.45rem', height: '1.45rem', borderRadius: '1.25rem', marginInlineEnd: '.25rem', boxShadow: '0 4px 16px 0 rgba(169, 184, 200, .15)' }} />
        Angelina
      </div>
    )
  }
];











